import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  Container,
  Paper,
  Fade,
  Zoom,
  Divider,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import FormularyIcon from "../imagenes/formlary_icon.png";
import useUser from "../hooks/useUser";

export default function ListadoFormulariosCategoriasSemanal() {
  const navigate = useNavigate();
  const user = useUser();
  const [showCards, setShowCards] = useState(false);

  const verificarUsuario = () => {
    if (!user.codigo_usuario) {
      alert("Debe autenticarse, Redirigiendo...");
      navigate("/login");
    }
  };

  useEffect(() => {
    verificarUsuario();
    setTimeout(() => setShowCards(true), 300);
  }, []);

  const cerrarSesion = () => {
    sessionStorage.clear();
    sessionStorage.setItem("token", null);
    user.codigo_usuario = null;
    navigate("/login");
  };

  const formularios = [
    {
      codigo: " PDS-CC-FR-002",
      nombre: "Limp. Bod Almacenamiento",
      ruta: "/reporte-PDS-CC-FR-002",
    },
    {
      codigo: "PDS-CC-FR-004",
      nombre: "Limpieza de Graneleros",
      ruta: "/reporte-PDS-CC-FR-004",
    },
   
    {
      codigo: "PDS-CC-FR-004-V3",
      nombre: "Limpieza de Graneleros V3",
      ruta: "/reporte-PDS-CC-FR-004-V3",
    },
    {
      codigo: "PDS-CC-FR-005",
      nombre: "Limpieza de Produccion",
      ruta: "/reporte-PDS-CC-FR-005",
    },
    {
      codigo: "PDS-PR-FR-006",
      nombre: "Arcos de Desinfección",
      ruta: "/reporte-PDS-PR-FR-006",
    },
    {
      codigo: "PDS-CC-FR-007",
      nombre: "Pesos Sacos Producto T.",
      ruta: "/reporte-PDS-CC-FR-007",
    },
    {
      codigo: "PDS-CC-FR-010",
      nombre: "Limp. Desinfección Tarimas",
      ruta: "/reporte-PDS-CC-FR-010",
    },
    {
      codigo: "PDS-CC-FR-036",
      nombre: "Productos Vencidos y Prox.",
      ruta: "/reporte-PDS-CC-FR-036",
    },
    {
      codigo: "PDS-CC-FR-041",
      nombre: "Inspección Higiene de Personal",
      ruta: "/reporte-PDS-CC-FR-041",
    },
    {
      codigo: "PDS-CC-FR-042",
      nombre: "Evaluación Retenedor Metales",
      ruta: "/reporte-PDS-CC-FR-042",
    },
    {
      codigo: "PDS-CC-FR-050",
      nombre: "Limpieza Área Molino",
      ruta: "/reporte-PDS-CC-FR-050",
    },
    {
      codigo: "PDS-CC-FR-056",
      nombre: "Limpieza Centro Acopio",
      ruta: "/reporte-PDS-CC-FR-056",
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 4, backgroundColor: "#fdfdfd" }}>
        {/* Encabezado */}
        <Fade in={true} timeout={500}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "center", md: "flex-start" },
              mb: 4,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  textAlign: { xs: "center", md: "left" },
                  color: "#0d47a1",
                  mb: 1,
                  letterSpacing: 1,
                }}
              >
                Formularios Semanales
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "#546e7a",
                  mb: 2,
                }}
              >
                Accede a los formularios para el control y seguimiento de procesos.
              </Typography>
              <Box
                sx={{
                  width: { xs: "60%", md: "250px" },
                  height: "4px",
                  backgroundColor: "#1976d2",
                  borderRadius: 2,
                  mx: { xs: "auto", md: 0 },
                  mb: { xs: 3, md: 0 },
                }}
              />
            </Box>
            <Button
              variant="contained"
              color="error"
              startIcon={<LogoutIcon />}
              sx={{
                mt: { xs: 2, md: 0 },
                height: 45,
                minWidth: { xs: "100%", md: "180px" },
                px: 3,
                textTransform: "none",
                fontWeight: "bold",
                fontSize: "1rem",
                alignSelf: { xs: "center", md: "center" },
                boxShadow: 2,
                ":hover": {
                  backgroundColor: "#c62828",
                },
              }}
              onClick={cerrarSesion}
            >
              Cerrar Sesión
            </Button>
          </Box>
        </Fade>
        <Divider sx={{ mb: 4 }} />
        {/* Tarjetas */}
        <Grid container spacing={4} justifyContent="center">
          {formularios.map((form, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={form.codigo}>
              <Zoom in={showCards} timeout={500 + index * 200}>
                <Card
                  sx={{
                    borderRadius: 4,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    ":hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: "#37474f" }}>
                      {form.codigo}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: "#607d8b", mb: 2 }}>
                      {form.nombre}
                    </Typography>
                    <Box
                      component="img"
                      src={FormularyIcon}
                      alt={`${form.nombre} icon`}
                      sx={{
                        height: 120,
                        width: 150,
                        objectFit: "contain",
                        mx: "auto",
                        my: 2,
                      }}
                    />
                  </CardContent>
                  <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                      variant="contained"
                      size="medium"
                      startIcon={<VisibilityIcon />}
                      onClick={() => navigate(form.ruta)}
                      sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 3,
                        backgroundColor: "#1976d2",
                        ":hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      Ver
                    </Button>
                  </CardActions>
                </Card>
              </Zoom>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
}